import { apiClient, handleApiResponse } from './client'
import type { LayeredAnalytics, ApiResponse } from '@/types'

export interface StoreInfo {
  id?: string | number
  name?: string | { [locale: string]: string }
  domain?: string
  country?: string
  email?: string
}

export interface ProductsResponse {
  products: any[]
  pagination: { page: number; per_page: number; count: number }
}

export const storeService = {
  async getStore(storeId: string) {
    const res = await apiClient.get<{ success: boolean; data: StoreInfo }>(
      '/api/store',
      { store_id: storeId }
    )
    return res.data
  },

  async getAllStores() {
    const res = await apiClient.get<{ success: boolean; data: StoreInfo[] }>(
      '/api/user/stores'
    )
    return res.data
  },

  async getProducts(storeId: string, page = 1, perPage = 10) {
    const res = await apiClient.get<{ success: boolean; data: ProductsResponse }>(
      '/api/store/products',
      { store_id: storeId, page, per_page: perPage }
    )
    return res.data
  },

  // Get store-level layered analytics
  async getStoreAnalytics(storeId: string, windowDays: number = 7): Promise<LayeredAnalytics> {
    const response: ApiResponse<LayeredAnalytics> = await apiClient.get(
      `/api/store/funnel/analytics`,
      { store_id: storeId, window: windowDays }
    )
    return handleApiResponse(response)
  },
}

